import { registerQuery, useQuery } from 'data-fetching-client';
import { fetchEmailDeliverabilityStatus } from '../clients/fetchEmailDeliverabilityStatus';
const deliverabilityStatusResponses = {};
function fetchAllEmailDeliverabilityStatuses({
  emailAddresses
}) {
  const addressResponses = emailAddresses.map(emailAddress => {
    if (emailAddress in deliverabilityStatusResponses) {
      return deliverabilityStatusResponses[emailAddress];
    }
    deliverabilityStatusResponses[emailAddress] = fetchEmailDeliverabilityStatus({
      emailAddress
    });
    return deliverabilityStatusResponses[emailAddress];
  });
  return Promise.all(addressResponses).then(responses => {
    const flattenedStatuses = {};
    responses.forEach(({
      recipient,
      sendResult
    }) => {
      flattenedStatuses[recipient] = sendResult;
    });
    return flattenedStatuses;
  });
}
const query = registerQuery({
  fieldName: 'emailDeliverabilityStatuses',
  args: ['emailAddresses'],
  fetcher: fetchAllEmailDeliverabilityStatuses
});
export function useEmailDeliverabilityStatuses({
  emailAddresses,
  deferred
}) {
  const {
    data,
    loading,
    error
  } = useQuery(query, {
    skip: deferred,
    variables: {
      emailAddresses
    }
  });
  const deliverabilityStatuses = data ? data.emailDeliverabilityStatuses : {};
  return {
    deliverabilityStatuses,
    loading,
    error
  };
}